var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReduce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1036,
    transform: "translate(-1394 -78)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1033 -18H46V1140H-1033V-18Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1393,
    y: -17,
    width: 1439,
    height: 975,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.37182 1.02369C5.98705 1.02369 5.67528 1.33555 5.67528 1.72023V4.69009L1.18909 0.204836C1.05304 0.0688715 0.874815 0.000889301 0.696593 0.000889301C0.518279 0.000889301 0.339964 0.0688715 0.204 0.204929C-0.0680227 0.476951 -0.0680227 0.918 0.204092 1.18993L4.69046 5.67528H1.71995C1.33527 5.67528 1.02341 5.98714 1.02341 6.37182C1.02341 6.7565 1.33518 7.06836 1.71995 7.06836H6.37182C6.75659 7.06836 7.06836 6.7565 7.06836 6.37182V1.72014C7.06836 1.33555 6.75659 1.02369 6.37182 1.02369Z",
    fill: "#70738B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4901 18.8362C13.8748 18.8362 14.1866 18.5244 14.1866 18.1397V15.1697L18.8109 19.794C19.083 20.0661 19.524 20.0661 19.796 19.794C20.068 19.522 20.068 19.081 19.796 18.809L15.1718 14.1848H18.1416C18.5263 14.1848 18.8381 13.873 18.8381 13.4883C18.8381 13.1036 18.5263 12.7918 18.1416 12.7918H13.49C13.1052 12.7918 12.7934 13.1036 12.7934 13.4883V18.1397C12.7935 18.5244 13.1054 18.8362 13.4901 18.8362Z",
    fill: "#70738B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.19013 19.796L5.81395 15.1718V18.1416C5.81395 18.5263 6.12572 18.8382 6.51049 18.8382C6.89526 18.8382 7.20703 18.5263 7.20703 18.1416V13.4901C7.20703 13.1054 6.89526 12.7935 6.51049 12.7935H1.85909C1.47441 12.7935 1.16255 13.1054 1.16255 13.4901C1.16255 13.8747 1.47432 14.1866 1.85909 14.1866H4.82895L0.205033 18.811C-0.0669889 19.083 -0.0669889 19.524 0.205126 19.7961C0.476963 20.068 0.918013 20.068 1.19013 19.796Z",
    fill: "#70738B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6288 7.06836H18.2804C18.6652 7.06836 18.977 6.75649 18.977 6.37182C18.977 5.98714 18.6652 5.67528 18.2804 5.67528H15.3105L19.796 1.18947C20.068 0.917443 20.068 0.476393 19.7959 0.20437C19.6599 0.0684061 19.4816 0.000423908 19.3034 0.000423908C19.1252 0.000423908 18.9469 0.0684996 18.8108 0.204464L14.3253 4.69028V1.72023C14.3253 1.33555 14.0135 1.02369 13.6287 1.02369C13.244 1.02369 12.9322 1.33555 12.9322 1.72023V6.37182C12.9323 6.75659 13.2442 7.06836 13.6288 7.06836Z",
    fill: "#70738B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1036,
    fill: "none",
    transform: "translate(-1394 -78)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReduce);
export default __webpack_public_path__ + "static/media/reduce.059d9d635567c2213b2300ce5a6b0788.svg";
export { ForwardRef as ReactComponent };